/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = require('lib/util/helpers').imageLoaded;

(function(Module, $) {
	'use strict';

	/**
	 * Hover Container
	 *
	 * @author Yves De Bruyne
	 * @namespace Tc.Module
	 * @class HoverContainer
	 * @extends Tc.Module
	 */

	Module.HoverContainer = Module.extend({
		// The normal content element
		$normalDisplay: null,
		// The hover content element
		$hoverDisplay: null,
		// The transition’s name
		transitionName: null,
		// The transition
		transition: null,
		// The height of the hover component. false means: no fixed height, true means: height will be calculated from content
		height: true,
		// Whether there is an animation currently running
		isAnimating: false,
		// All pending animations
		animationQueue: null,

		/**
		 * Init, attach Events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			this.animationQueue = [];

			this.$normalDisplay = $ctx.find('> .normalDisplay').show();
			this.$hoverDisplay = $ctx.find('> .hoverDisplay').hide();
			this.transitionName = $ctx.data('transition');

			function finished() {
				Promise.all(mod.$normalDisplay.find('img').get().map(imageLoaded)).then(mod.initHover.bind(mod));
				callback();
			}

			if(document.readyState === 'complete') {
				finished();
			} else {
				$(window).on('load', finished);
			}
		},

		after: function () {
		},

		initHover: function() {
			this.initHeight();
			this.initTransition();

			this.$ctx.hover(
				$.proxy(this, 'run', this.$normalDisplay, this.$hoverDisplay, true),
				$.proxy(this, 'run', this.$hoverDisplay, this.$normalDisplay, false)
			);
		},

		initHeight: function() {
			var height = false;
			if(this.height === true) {
				// “Display” the hover element so we can calculate its size
				this.$hoverDisplay.css({
					display: '',
					visibility: 'hidden'
				});
				var heightInfo = {
					normal: this.$normalDisplay[0].clientHeight,
					hover: this.$hoverDisplay[0].clientHeight
				};
				height = Math.max(heightInfo.normal, heightInfo.hover);
				// Hide the hover element again
				this.$hoverDisplay.css({
					opacity: 0,
					visibility: ''
				});
			} else if(this.height) {
				height = this.height;
			}
			if(height) {
				this.$ctx.height(height);
			}
		},

		initTransition: function() {
			if(this.transitionName in Module.HoverContainer.Transitions) {
				this.transition = Module.HoverContainer.Transitions[this.transitionName];
			} else {
				this.transition = Module.HoverContainer.Transitions.swap;
			}
			if('init' in this.transition) {
				this.transition.init(this.$normalDisplay, this.$hoverDisplay, this.$ctx);
			}
		},

		run: function($from, $to, isToBackside) {
			var isAnimated = !(this.transition instanceof Function);
			var props = (isAnimated ? this.transition.properties : this.transition)(this.$ctx, isToBackside);
			if(isAnimated) {
				this.runAnimated($from, $to, props, isToBackside);
			} else {
				this.runStatic($from, $to, props, isToBackside);
			}
		},

		runStatic: function($from, $to, props) {
			$from.css(props.from);
			$to.css(props.to);
			this.$ctx.trigger('scs-active', [$to]);
		},

		runAnimated: function($from, $to, props, isToBackside) {
			if(this.isAnimating) {
				var args = [].slice.call(arguments);
				this.animationQueue.push(args);
				return;
			}
			this.isAnimating = true;
			if('prepare' in this.transition) {
				this.transition.prepare($from, $to, this.$ctx, isToBackside);
			}
			var completed = 2;
			var complete = $.proxy(function() {
				if((completed -= 1) !== 0) {
					// Wait for second animation to finish.
					return;
				}
				if('finish' in this.transition) {
					this.transition.finish($from, $to, this.$ctx, isToBackside);
				}
				this.isAnimating = false;
				this.animationQueueStep();
				this.$ctx.trigger('scs-active', [$to]);
			}, this);
			$from.animate(props.from, Module.HoverContainer.ANIMATION_OPTIONS.extend({
				complete: complete
			}));
			$to.animate(props.to, Module.HoverContainer.ANIMATION_OPTIONS.extend({
				complete: complete
			}));
		},

		animationQueueStep: function() {
			while(this.animationQueue.length > 1) {
				if(this.animationQueue[0][3] === this.animationQueue[1][3]) {
					// The two queue items point to the same endpoint… coalesce them
					this.animationQueue.splice(0, 1);
				} else {
					// The two queue items complement one another… delete both
					this.animationQueue.splice(0, 2);
				}
			}
			if(this.animationQueue.length) {
				var step = this.animationQueue.shift();
				this.runAnimated.apply(this, step);
			}
		}
	});

	Module.HoverContainer.ANIMATION_OPTIONS = {
		queue: false,
		duration: 600,
		extend: function(opts) {
			return $.extend({}, this, opts, {extend: undefined});
		}
	};

	Module.HoverContainer.Transitions = {
		dissolve: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative'
				});
				$normalDisplay.add($hoverDisplay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
			},
			prepare: function($from, $to) {
				$from.css({
					zIndex: 1
				});
				$to.css({
					zIndex: 2,
					display: '',
					opacity: 0
				});
			},
			properties: function() {
				return {
					from: {
						opacity: 0
					},
					to: {
						opacity: 1
					}
				};
			},
			finish: function($from) {
				$from.hide();
			}
		},
		push: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative',
					overflow: 'hidden'
				});
				$normalDisplay.add($hoverDisplay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
			},
			prepare: function($from, $to, $ctx, isToBackside) {
				var direction = isToBackside ? 1 : -1;
				$from.css({
					left: 0
				});
				$to.css({
					display: '',
					left: direction * $ctx.width()
				});
			},
			properties: function($ctx, isToBackside) {
				var direction = isToBackside ? -1 : 1;
				return {
					from: {
						left: direction * $ctx.width()
					},
					to: {
						left: 0
					}
				};
			},
			finish: function($from) {
				$from.hide();
			}
		},
		swap: function() {
			return {
				from: {
					opacity: '0',
					position: 'absolute'
				},
				to: {
					opacity: '1',
					position: 'relative',
					display: ''
				}
			};
		},
		fadein: function() {
			return {
				from: {
					opacity: '0',
					transition: 'opacity .4s ease-in-out',
					position: 'absolute'
				},
				to: {
					opacity: '1',
					position: 'relative',
					transition: 'opacity .4s ease-in-out',
					display: ''
				}
			};
		},
		// Only works with background containers
		fade: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative'
				});
				var $text = $hoverDisplay.find('.modBackgroundContainer > * > .parsys').eq(0).find('*');
				$text.css({
					color: '#1af' //Swisscom blue
				});
				var $overlay = $('<div/>');
				$overlay.css({
					zIndex: 3,
					backgroundColor: '#85d5ff', //Swisscom light blue
					display: 'none'
				});
				$ctx.append($overlay);
				$ctx.data('hover-overlay', $overlay);
				$normalDisplay.css({zIndex: 1});
				$hoverDisplay.css({zIndex: 0, display: ''});
				$normalDisplay.add($hoverDisplay).add($overlay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
				$.easing.swingAndBack = function(time, b, c, d) {
					time = 1 - Math.abs(time * 2 - 1); //Should go from 0 to 1 to 0
					return $.easing.swing(time, b, c, d);
				};
			},
			prepare: function($from, $to, $ctx) {
				$to.show();
				$ctx.data('hover-overlay').css({
					opacity: 0,
					display: ''
				}).animate({
					opacity: 0.5
				}, Module.HoverContainer.ANIMATION_OPTIONS.extend({
					easing: 'swingAndBack'
				}));
			},
			properties: function($ctx, isToBackside) {
				return {
					from: {
						opacity: isToBackside ? 0 : 1
					},
					to: {
						opacity: 1
					}
				};
			},
			finish: function($from, $to, $ctx, isToBackside) {
				if(isToBackside) {
					$from.hide();
				}
				$ctx.data('hover-overlay').hide();
			}
		}
	};

})(window.Tc.Module, window.Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.HoverContainer.js
// module id = 145
// module chunks = 0